export default "__VITE_ASSET__wG72rIPu__"